export enum DelayTypeEnum {
    Reservation = 0,
    Emptyout = 1,
    Limitation = 2,
    InputLimit = 3,
    Permanence = 4,
}
